/**
 * @fileoverview Bonus Turn Test Suite
 *
 * Tests for bonus turn mechanics.
 */

import { PieceType } from "../../zodiacEngine/types";
import { IntegrationTest, TestSuite } from "../types";

export const bonusTurnTests: IntegrationTest[] = [
  // ============ PENGUIN ============
  // Penguin slide grants bonus turn (rotation phase)
  {
    name: "Penguin slides forward",
    description: "Light Penguin slides from C1 towards C7 (facing up) - grants bonus turn for rotation",
    inputFEN: "8/8/P↑K6m/8/7bk",
    lightKing: PieceType.Penguin,
    darkKing: PieceType.Bear,
    move: "Light Penguin C1->C7",
    expectedFEN: "8/8/6P↑Km/8/7bk",
    expectedDelta: {
      pieceMoved: "Light Penguin slid [C1 -> C7]",
      turnChanged: false, // Bonus turn - same player continues
      bonusTurn: true,
      gameEnded: false,
    },
  },

  // ============ MONKEY CONSUME FUNGI ============
  // Monkey consumes fungi to gain bonus turn
  {
    name: "Monkey consumes fungi",
    description: "Light Monkey consumes Dark Fungi for bonus turn",
    inputFEN: "8/8/MK7/1u6/7bk",
    lightKing: PieceType.Monkey,
    darkKing: PieceType.Bear,
    move: "Light Monkey C1->D2:consume",
    expectedFEN: "8/8/8/1MK6/7bk",
    expectedDelta: {
      pieceMoved: "Light Monkey consumed Dark Fungi [C1 -> D2] and gets a bonus turn",
      statusChanged: false,
      turnChanged: false, // Consume grants bonus turn
      bonusTurn: true,
      gameEnded: false,
    },
  },

  // ============ MONKEY SWING FROM TREE ============
  // Monkey swings from tree to move farther
  {
    name: "Monkey swings from tree",
    description: "Light Monkey swings over Light Tree",
    inputFEN: "8/8/MKT6/8/7bk",
    lightKing: PieceType.Monkey,
    darkKing: PieceType.Bear,
    move: "Light Monkey C1->C3:swing",
    expectedFEN: "8/8/1TMK5/8/7bk",
    expectedDelta: {
      pieceMoved: "Light Monkey swung over Light Tree [C1 -> C3] Light Monkey gets a bonus turn",
      statusChanged: false,
      turnChanged: false,
      bonusTurn: true,
      gameEnded: false,
    },
  },

    // ============ Virus infect chains ============
  // Virus can move again with any legal move after an initial infect
  {
    name: "Virus infect bonus turn",
    description: "Light virus gets a bonus turn",
    inputFEN: "V7/8/MK7/8/W6bk",
    lightKing: PieceType.Monkey,
    darkKing: PieceType.Bear,
    move: "Light Virus A1->C1:infect",
    expectedFEN: "8/8/MK+V7/8/W6bk",
    expectedDelta: {
      pieceMoved: "Light Virus infected Light Monkey [A1 -> C1]",
      statusChanged: true,
      turnChanged: false,
      bonusTurn: true,
      gameEnded: false,
    },
  },
];

export const bonusTurnsSuite: TestSuite = {
  name: "Bonus Turns",
  description: "Tests for bonus turn mechanics (Monkey, Virus, Penguin)",
  tests: bonusTurnTests,
};
